<template>
<v-card flat v-bind='attrs' >
  <request-status :request='request' :message200='false' />
  <v-card-title class='overline grey lighten-4 py-0' >
      <v-btn @click='debounceExpensiveMethod' :loading='request.loading' small icon class='ml-1 pl-0' >
        <v-icon small >replay</v-icon>
      </v-btn>
      <v-divider class='mr-3' vertical></v-divider>
      <slot name='toolbar-before' ></slot>
      <v-menu v-if='views && views.length > 0' >
        <template v-slot:activator="{ on }">
        <v-btn v-on='on' slot='activator' small outline >
          {{selectedView.title}}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
        </template>
        <v-card>
          <v-card-title class='overline py-1 my-0 grey lighten-4'>
            Quick filters
          </v-card-title>
          <v-list class='pa-0'>
            <v-divider />
            <template v-for='view in views' >
              <v-list-tile
                :key='view.title'
                @click='selectedView=view' >
                <v-list-tile-content>
                  <v-list-tile-title v-text='view.title' />
                </v-list-tile-content>
              </v-list-tile>
              <v-divider :key='`div-${view.title}`' />
            </template>
          </v-list>
        </v-card>
      </v-menu>
      <span v-else v-text='title' />

      <v-spacer></v-spacer>
      <slot name='toolbar' ></slot>
      <slot name='pagination' >
        <template v-if='totalPages && totalPages > 1'>

          <v-btn
            v-if='totalPages > 3'
            @click='page=1' :disabled='page <= 2 || request.loading' icon small class='hidden-xs-only' >
            <v-icon small >fast_rewind</v-icon>
          </v-btn>

          <v-btn @click='page--' :disabled='page <= 1 || request.loading' icon small >
            <v-icon small >chevron_left</v-icon>
          </v-btn>
          <span class='ml-2' >
            {{ Math.max(1, (page - 1) * pageSize) }} -
            {{ Math.min(numResults, page * pageSize) }} of
            {{numResults}}
          </span>
          <v-btn @click='page++' :disabled='page >= totalPages || request.loading' icon small >
            <v-icon small >chevron_right</v-icon>
          </v-btn>

          <v-btn
            v-if='totalPages > 3'
            @click='page=totalPages' :disabled='page >= totalPages || request.loading' icon small class='hidden-xs-only' >
            <v-icon small >fast_forward</v-icon>
          </v-btn>

        </template>
      </slot>
      <!-- {{numResults}} / {{pageSize}} | {{totalPages}} -->
      <v-spacer class='hidden-sm-and-up' ></v-spacer>
      <template v-if='withAdd' >
        <v-divider vertical ></v-divider>
        <v-btn class='mr-0' icon small >
          <v-icon small >add</v-icon>
        </v-btn>
      </template>

      <slot name='toolbar-end' ></slot>

      <template>
        <v-btn v-if="cards" @click="$emit('update:cards', false)" icon ><v-icon>unfold_less</v-icon></v-btn>
        <v-btn v-else @click="$emit('update:cards', true)" icon ><v-icon>unfold_more</v-icon></v-btn>
      </template>

      <template v-if='multiple && withSelectAll' >
        <v-icon v-if='selectAll===false' @click="selectAll=true" >check_box_outline_blank</v-icon>
        <v-icon v-else @click="selectAll=false" >check_box</v-icon>
      </template>
  </v-card-title>
  <slot name="top" ></slot>
  <v-divider></v-divider>

  <v-list subheader three-line :dense='dense' class='pa-0 elevation-0 grey lighten-4' >
    <template v-if='withSearch' >
      <v-text-field single-line hide-details
        class='ma-0 pl-3 pt-0' prepend-inner-icon='search' label='search within results' ></v-text-field>
      <v-divider ></v-divider>
    </template>

    <v-card v-for='(appt, index) in filteredAppointments' :key="`card-${appt.id}`" :flat="!cards" :class="{'ma-2': cards}" >
      <v-subheader
        class='overline py-0 my-0 grey lighten-4'
        v-if="withSubheaders && isNewCategory(index, filteredAppointments, 'title')" >
          {{appt.title}}
      </v-subheader>
      <appointment-list-item v-else
        @listitem:clicked='appointmentSelected'
        v-bind='listAttrs'
        :appointment='appt'
        :with-actions='false'
        :with-action='withAction'
        :with-pricing='withPrice'
        :with-color-coding='false'
        :with-status-chips='true'
        :class='{"cyan lighten-4": isSelected(appt)}' >
        <template v-if='withActions' slot='actions' >
          <slot name='listaction' :appointment='appt' >
          <v-btn @click.stop='showOptions(appt)' icon small >
            <v-icon>more_vert</v-icon>
          </v-btn>
          </slot>
        </template>
        <template v-else slot='actions' >
          <slot name='listaction' :appointment='appt' ></slot>
        </template>
        <template v-if='multiple' slot='action' >
          <v-divider class='ml-1' vertical ></v-divider>
          <v-list-tile-action >
            <v-btn icon >
              <v-icon v-if='isSelected(appt)' >check_box</v-icon>
              <v-icon v-else >check_box_outline_blank</v-icon>
            </v-btn>
            <!-- <v-checkbox :value='' :disabled='disabled' ></v-checkbox> -->
          </v-list-tile-action>
        </template>
      </appointment-list-item >

      <v-divider ></v-divider>

      <v-card flat
        @click="launchDiagnosisCodes({value: appt, appointmentId: appt.id, editable: true, withTitle: true, withTotal: true, withRefresh: true, withInvoiceable: true})"
        v-if="cards && appt.codes && appt.codes.length > 0"
        class="ma-0" >
        <v-card-title class='pb-0 pt-1 overline' >Codes
          <!-- <v-spacer/>
          <v-btn icon small ><v-icon small >edit</v-icon></v-btn> -->
        </v-card-title>
        <v-card-text>
          <v-layout v-for="code in appt.codes" :key="code.id" >
            <v-flex xs6 >{{code.icd10}}</v-flex>
            <v-flex xs3 >{{code.process}}</v-flex>
            <v-flex xs3 style="text-align:right;" >
              {{formatCurrency(code.currency, code.price) }}
            </v-flex>
            <!-- <pre v-text="code" /> -->
          </v-layout>
        </v-card-text>
      </v-card>

    </v-card>

    <v-list-tile v-if='filteredAppointments && filteredAppointments.length === 0' >
      <v-list-tile-content >
        <v-list-tile-title v-text='noResultsText' />
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <appointment-bottom-sheet
    v-if='withActions && selectedAppointment && selectedAppointment.id'
    v-model='showBottomSheet'
    :appointment='selectedAppointment' />
</v-card>
</template>
<script>
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import AppointmentBottomSheet from '@/components/appointment/actions/AppointmentBottomSheet.vue'
// import Vue from 'vue'
export default {
  components: {
    AppointmentListItem,
    AppointmentBottomSheet
  },
  props: {
    title: { type: String, default: 'Appointments' },
    selected: { type: Array, default: () => { return [] } },
    params: { type: Object, default: () => {} },
    facets: { type: String },
    ordering: { type: String },
    views: { type: Array, default: () => { return [] } },
    dense: { type: Boolean, default: false },
    cards: { type: Boolean, default: false },
    noResultsText: { type: String, default: 'No appointments found' },
    loading: { type: Boolean, default: false },
    withSelectAll: { type: Boolean, default: false },
    withPrice: { type: Boolean, default: true },
    withActions: { type: Boolean, default: true },
    withAdd: { type: Boolean, default: false },
    withAction: { type: Boolean, default: false },
    withSearch: { type: Boolean, default: false },
    withSubheaders: { type: Boolean, default: false },
    groupByName: { type: Boolean, default: false },
    groupByMonth: { type: Boolean, default: false },
    listAttrs: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    pageSize: { type: Number, default: 20 },
    attrs: { type: Object, default: () => {} },
    multiple: { type: Boolean, default: true },
    touch: { type: Number, default: 0 }
  },
  name: 'AppointmentList',
  data () {
    return {
      page: 1,
      selectAll: false,
      localSelected: [],
      request: {
        resource: 'ag.practitioner.appointments',
        loading: false
      },
      timeout: null,
      selectedAppointment: null,
      selectedView: {},
      initted: false,
      showBottomSheet: false
    }
  },
  mounted () {
    this.debounceExpensiveMethod()
    if (this.views && this.views.length > 0) {
      this.selectedView = this.views[0]
    }
  },
  watch: {
    params () {
      this.page = 1
      this.selectAll = false
      this.debounceExpensiveMethod()
    },
    touch () {
      this.page = 1
      this.selectAll = false
      this.debounceExpensiveMethod()
    },
    globalappdialogwatcher () {
      this.debounceExpensiveMethod()
    },
    selectAll () {
      if (this.selectAll === true) {
        let copy = this.filteredAppointments.slice()
        // Vue.set(this, 'localSelected', copy)
        this.$emit('update:selected', copy)
      } else {
        this.$emit('update:selected', [])
      }
    },
    selectedView: {
      deep: true,
      handler () {
        this.$emit('update:params', this.selectedView.params)
      }
    },
    selected: {
      immediate: true,
      handler () {
        if (this.selected) {
          this.localSelected = this.selected
          if (this.multiple) {
            this.globalSelectedAppointments = this.selected
          }
        }
      }
    },
    localSelected () {
      this.$emit('update:selected', this.selected)
    },
    numGloballySelectedAppointments () {
      if (this.numGloballySelectedAppointments === 0) {
        this.$emit('update:selected', [])
      }
    },
    page () {
      this.$emit('update:selected', [])
      this.localSelected = []
      this.globalSelectedAppointments = []
      this.debounceExpensiveMethod()
    },
    numResults () {
      this.$emit('count', this.numResults)
    },
    requestStatus () {
      this.$emit('update:request', this.request)
      if (this.requestStatus > 0) {
        this.timeout = null
        this.initted = true
      }
    },
    requestLoading () {
      this.$emit('update:loading', this.requestLoading)
    }
  },
  methods: {
    showOptions (appt) {
      this.selectedAppointment = appt
      this.showBottomSheet = false
      window.setTimeout(() => {
        this.showBottomSheet = true
      }, 100)
    },
    debounceExpensiveMethod () {
      this.request.loading = true
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      this.timeout = window.setTimeout(this.fetch, 1000)
    },
    fetch () { // debounce this
      this.$emit('update:selected', [])
      this.request.params = {}
      if (this.params) {
        this.request.params = this.params
      }
      this.request.params['page'] = this.page
      if (this.facets) {
        this.request.params.facets = this.facets
      }
      if (this.ordering) {
        this.request.params.ordering = this.ordering
      }
      this.$request('get', this.request)
    },
    isSelected (appointment) {
      return this.selected.find((selected) => {
        return selected.id === appointment.id
      })
    },
    appointmentSelected (appointment) {
      if (this.disabled) { return }
      this.selectedItem = appointment
      if (!this.selected) { return [] }
      let selectedIndex = this.selected.findIndex((selected) => {
        return selected.id === appointment.id
      })
      if (selectedIndex >= 0) {
        this.localSelected.splice(selectedIndex, 1)
      } else {
        this.localSelected.push(appointment)
      }
      this.$emit('input', this.selectedItem)
    },
    isNewCategory (index, arr, key) {
      if (index === 0) { return true }
      if (arr[index - 1][key] !== arr[index][key]) { return true }
      return false
    }
  },
  computed: {
    numGloballySelectedAppointments () {
      if (this.globalSelectedAppointments && this.globalSelectedAppointments.length > 0) {
        return this.globalSelectedAppointments.length
      }
      return 0
    },
    appointments () {
      return this.getObjectPath(this.request, 'result.results', [])
    },
    requestStatus () {
      return this.request.status
    },
    requestLoading () {
      return this.request.loading
    },
    numResults () {
      return this.getObjectPath(this.request, 'result.count', null)
    },
    totalPages () {
      if (this.pageSize && this.numResults) {
        return Math.ceil(this.numResults / this.pageSize)
      }
      return 1
    },
    filteredAppointments () {
      let appointments = this.appointments
      if (this.client && this.client.id) {
        return appointments.filter((appt) => {
          let clientId = appt.client
          if (clientId.id) { clientId = clientId.id }
          return (
            clientId.toString() === this.client.id.toString()
          )
        })
      }
      return appointments
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentList.vue?5347ee00